"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _parseToRgb = _interopRequireDefault(require("polished/lib/color/parseToRgb"));

var _base = _interopRequireDefault(require("./base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PACIFIC_OCEAN = (0, _parseToRgb.default)('#1C6EE6');
var ARCTIC_OCEAN = (0, _parseToRgb.default)('#6EBEFF');
var INDIAN_OCEAN = (0, _parseToRgb.default)('#61B0FF');
var ATLANTIC_OCEAN = (0, _parseToRgb.default)('#0094FF');
var RED_WINE = (0, _parseToRgb.default)('#7A2D8A');
var ROSE_WINE = (0, _parseToRgb.default)('#D0ABFF');
var interaction = {
  pacificOcean: _objectSpread({}, PACIFIC_OCEAN, {
    fg: _base.default.snowWhite
  }),
  indianOcean: _objectSpread({}, INDIAN_OCEAN, {
    fg: _base.default.charcoal
  }),
  pacificOcean15: _objectSpread({}, PACIFIC_OCEAN, {
    alpha: 0.15,
    fg: _base.default.charcoal
  }),
  pacificOcean40: _objectSpread({}, PACIFIC_OCEAN, {
    alpha: 0.4,
    fg: _base.default.charcoal
  }),
  redWine: _objectSpread({}, RED_WINE, {
    fg: _base.default.charcoal
  }),
  arcticOcean: _objectSpread({}, ARCTIC_OCEAN, {
    fg: _base.default.charcoal
  }),
  atlanticOcean: _objectSpread({}, ATLANTIC_OCEAN, {
    fg: _base.default.snowWhite
  }),
  arcticOcean15: _objectSpread({}, ARCTIC_OCEAN, {
    alpha: 0.15,
    fg: _base.default.snowWhite
  }),
  arcticOcean40: _objectSpread({}, ARCTIC_OCEAN, {
    alpha: 0.4,
    fg: _base.default.snowWhite
  }),
  roseWine: _objectSpread({}, ROSE_WINE, {
    fg: _base.default.charcoal
  })
};
var _default = interaction;
exports.default = _default;